import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';

export interface RoundPanelProps {
  shadow?: 'small' | 'large';
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
}

export const RoundPanel: React.FC<RoundPanelProps> = ({
  children,
  shadow = 'large',
  style,
}) => (
  <Panel shadow={shadow} style={style}>
    {children}
  </Panel>
);

const shadows = {
  small: {
    shadowOffset: '0px 0px',
    shadowRadius: '16px',
    shadowOpacity: 0.1,
    shadowColor: 'rgb(153, 153, 153)',
  },
  large: {
    shadowOffset: '0px 0px',
    shadowRadius: '24px',
    shadowOpacity: 0.1,
    shadowColor: 'rgb(0, 0, 0)',
  },
};

type StyledPanelType = {
  backgroundColor?: string;
  width?: string | number;
  shadow: 'small' | 'large';
};

const Panel = styled.View<StyledPanelType>`
  border-radius: 16px;
  margin: 20px;
  shadow-offset: ${({ shadow }) => shadows[shadow].shadowOffset};
  shadow-color: ${({ shadow }) => shadows[shadow].shadowColor};
  shadow-radius: ${({ shadow }) => shadows[shadow].shadowRadius};
  shadow-opacity: ${({ shadow }) => shadows[shadow].shadowOpacity};
  elevation: 1;
`;
export default RoundPanel;
